import React from 'react'
import { Toaster } from '@/components/ui/sonner'

export default function GlobalToaster() {
  return <Toaster position="bottom-right" />
}